import { render, staticRenderFns } from "./CardTypes.vue?vue&type=template&id=8afc77b2&scoped=true"
import script from "./CardTypes.vue?vue&type=script&lang=js"
export * from "./CardTypes.vue?vue&type=script&lang=js"
import style0 from "./CardTypes.vue?vue&type=style&index=0&id=8afc77b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afc77b2",
  null
  
)

export default component.exports